module.exports = __webpack_public_path__ + "img/ntpp4.da49e3fa.png";